module.exports = __webpack_public_path__ + "static/623942c1e36711373846741a8d4d84b1b708aacc74a8918609f9a0a920d616bc-549a3dc899eed28334f9fc87246f6e01.jpeg";